import { useUserModuleState } from "..";

export default function useTrackStatus(trackId: TrackId) {
    const {tracks} = useUserModuleState();

    const track = tracks.find(t => t.id === trackId);

    return track ? track.status : 'active';
}
